import { AttrField, BelongsToField, BooleanField, NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import User from '@/data/models/domain/User'
import type { LabelColor } from '@/services/domain/label/types'

@OrmModel(modelNames.CONTACT_LIST_FOLDER)
export default class ContactListFolder extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public name: string

  @StringField()
  public color: LabelColor

  @AttrField()
  public folderId: string | null

  @StringField()
  public userId: string

  @StringField()
  public createdAt: string

  @AttrField()
  public lastUpdatedAt: string | null

  @NumberField()
  public foldersCount: number

  @NumberField()
  public listsCount: number

  @BooleanField()
  public isHidden: boolean

  @BelongsToField(User, 'userId')
  public user: User
}
